import { MonthWiseAttendanceDto } from "./month-wise-attendance-dto";

  export class MonthWiseAttendanceDetailsDto{
    empName:string;
    empId:number;
    attendanceDetails:MonthWiseAttendanceDto[];
    totalPresents: number;
    totalLeaves: number;
    totalHolidays: number;
}